exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "sickness-leave-date .leave-date-known-form{margin-top:35px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/sicknessLeaveDate/sicknessLeaveDate.scss
// module id = 1526
// module chunks = 0